import AV from 'leancloud-storage';
var APP_ID = 'u4iB7Lu1Pe8XqJsITRwFFhV5-gzGzoHsz';
var APP_KEY = 'GPkePG17AlJGYunRvLYtpoEj';

AV.init({
  appId: APP_ID,
  appKey: APP_KEY
});

export default AV


// WEBPACK FOOTER //
// ./src/js/api/av.js